module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[69]190.1945b2f.woff2";